import React, { Fragment, useMemo, useState } from 'react';
import { Button, Col, Collapse, DatePicker, Row, Select, Table, Tooltip } from 'antd';
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaJournalWhills } from "react-icons/fa";

import '../css/collasible.css';
import ReportsToPDF from '../components/ReportsToPDF';
import { BlobProvider } from '@react-pdf/renderer';
import { useLoaderData, useParams } from 'react-router-dom';
import GHSymbol from '../components/GHSymbol';
import formatAmount from '../../utils/formatAmount';


const options = [
  {
    value: 'jack',
    label: 'Jack',
  },
  {
    value: 'lucy',
    label: 'Lucy',
  },
  {
    value: 'Yiminghe',
    label: 'yiminghe',
  },
];

const columns = [
  {
    title: 'Reference',
    dataIndex: 'reference',
    key: 'reference',
    className: 'whitespace-nowrap font-medium text-black font-normal dark:text-white',
    width: '17%'
  },
  {
    title: 'Account',
    dataIndex: 'account',
    key: 'account',
    className: 'whitespace-nowrap font-medium text-black font-normal dark:text-white',
    width: '17%',
    ellipsis: true
  },
  {
    title: 'Label',
    dataIndex: 'label',
    key: 'label',
    className: 'whitespace-nowrap font-medium text-black font-normal dark:text-white',
    width: '25%',
    ellipsis: true
  },
  {
    title: 'Debit',
    dataIndex: 'debit',
    key: 'debit',
    className: 'whitespace-nowrap font-medium text-black font-normal dark:text-white',
    width: '10%',
  },
  {
    title: 'Credit',
    dataIndex: 'credit',
    key: 'credit',
    className: 'whitespace-nowrap font-medium text-black font-normal dark:text-white',
    width: '10%',
  },
  {
    title: 'Taxes',
    dataIndex: 'tax',
    key: 'tax',
    className: 'whitespace-nowrap font-medium text-black font-normal dark:text-white',
    width: '15%'
  },

]


const newCell = ({ record, dataIndex, ...restProps}) => {
  return (
    <td {...restProps} key={record.id}>
      
      {record.transactions.map((arr, idx) => 
        <div key={idx}>
          {idx === 0 && record[dataIndex]}
          {/* {record[dataIndex]} */}
          {
            arr[dataIndex] ? arr[dataIndex] : <span style={{color: 'white'}}>{idx > 0 && '.'}</span>
          }
          {/* {arr[dataIndex] ! && arr[dataIndex]} */}
        </div>
      )}
    </td>
  )
}


const JournalReports = () => {
  const [filter, setFilter] = useState({date: '', journal_code: ''})
  const reports = useLoaderData();
  const params = useParams();

  const onChangeDate = (date, dateString) => setFilter({ ...filter, date: dateString });
  const onChangeJournal = (v) => setFilter({ ...filter, journal_code: v });
  

  // const memoizedDocument = useMemo(() => <ReportsToPDF data={report} reportType={'Journal Report'} />, []);

  const mergedColumns = columns.map((col) => {
    return {
    ...col,
    onCell: (record) => ({
      record,
      dataIndex: col.dataIndex
    })}})

  return (
    <div className='container mx-auto h-full' style={{maxWidth: '1200px'}}>
      <div className='bg-white mb-3 p-1'>
        <div>
          <h2 className='font-semibold text-xl text-[#04949b]'>{'Journal Report'}</h2>
        </div>
        <div className='flex justify-between p-2'>
          {/* <div>
            <Button className='bg-[#04949b] text-white border-0 hover:bg-[#04949b] font-semibold'>
              <BlobProvider document={memoizedDocument}>
                  {({ url, loading, error }) => {
                    if (loading) return 'Loading document...';
                    if (error) return 'Error loading document';
                    return (
                      <a href={url} target="_blank" rel="noopener noreferrer">
                        PDF
                      </a>
                    );
                  }}
                </BlobProvider>
            </Button>
          </div> */}
          <Row className='w-1/2'>
            <Col lg={10} className='flex items-center text-[#04949b] w-1/2'>
              <span className='w-1/2 font-normal flex items-center font-semibold'><FaRegCalendarAlt className='me-1'/>As of</span>
              <DatePicker suffixIcon={false} defaultValue={filter.date} onChange={onChangeDate} className='border-x-0 border-t-0 ps-0 text-[#04949b] font-semibold focus:shadow-none input-outline-none w-full border-0 font-normal'/>
            </Col>
            <Col lg={10} className='flex items-center text-[#04949b] w-1/2'>
              <span className='w-1/2 font-normal flex items-center font-semibold'><FaJournalWhills className='me-1'/>Journals:</span>
              <Select variant="borderless" value={filter.journal_code} onChange={onChangeJournal} suffixIcon={false} className='w-full font-semibold text-[#04949b]' options={options}/>
            </Col>
          </Row>
        </div>
      </div>
      <div className='bg-white p-3'>
        <div className='mb-2'>
        {reports.map(report =>
          <Collapse key={report.id} defaultActiveKey={['1']} ghost className='m-0 p-0' 
            items={
              [
                {
                  key: 0,
                  label: `${report.name}`,
                  children: 
                  <>
                    <Table 
                      columns={mergedColumns}
                      dataSource={report.reports}
                      pagination={false}
                      scroll={{ x: 1200 }}
                      components={{ body: {
                        cell: newCell
                      }}}
                    />
                  </>
                }
              ]
            }
          />
        )}
        </div>
        {/* <div className='mb-2'>
          <h4 className='border-b-2 border-black'>LIABILITY</h4>
          <div className='ms-4'>
            <h5 className='border-b-2'>Current Liabilities</h5>
            <div className='ms-4'>
              <Collapse defaultActiveKey={['1']} ghost items={liabilityItems} className='m-0 p-0'/>
            </div>
          </div>
        </div> */}
        {/* <div className='mb-2'>
          <h4 className='border-b-2 border-black'>EQUITY</h4>
          <div className='ms-4'>
            <h5 className='border-b-2'>Unallocated Earnings</h5>
            <div className='ms-4'>
              <h6 className='border-b-2'>Current Year Unallocated Earnings</h6>
              <div className='ms-4'>
                <p className='m-0 border-b-2 text-[#04949b]'>Current Year Earnings</p>
                <p className='m-0 border-b-2'>Current Year Allocated Earnings</p>
              </div>
              <h6 className='border-b-2'>Previous Years Unallocated Earnings</h6>
            </div>
            <h5>Retained Earnings</h5>
          </div>
        </div> */}
      </div>
    </div>
  )
};

export default JournalReports;